<p class="block_title">Настройки профиля</p>
<hr>
<section class="main-profile-settings" *ngIf="profile">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="main-profile-settings__profile">
    <span class="main-profile-settings__profile_photo">
      <div class="foto-wrapper">
        <img *ngIf="hasProfilePhoto" src="{{ profile.avatar }}" [alt]="profile.user.username">
      </div>
      <input placeholder="ваше фото"
            formControlName="avatar"
            type="file"
            class="foto-button"
            (change)="updateProfilePhoto($event)">
    </span>
    <span class="main-profile-settings__profile_name">
      <div class="form-wrapper">
        <mat-form-field hintLabel="Max 35 символов" appearance="outline">
          <mat-label>Имя</mat-label>
          <input matInput #firstName placeholder="ваше имя" formControlName="firstName">
          <mat-error *ngIf="form.controls.firstName.invalid">Некоректные данные</mat-error>
          <mat-hint align="end">{{ firstName.value?.length || 0 }}/35</mat-hint>
        </mat-form-field>
        <mat-form-field hintLabel="Max 35 символов" appearance="outline">
          <mat-label>Фамилия</mat-label>
          <input matInput #lastName placeholder="ваша фамилия" formControlName="lastName">
          <mat-error *ngIf="form.controls.lastName.invalid">Некоректные данные</mat-error>
          <mat-hint align="end">{{ lastName.value?.length || 0 }}/35</mat-hint>
        </mat-form-field>
        <mat-form-field hintLabel="Max 35 символов" appearance="outline">
          <mat-label>Отчество</mat-label>
          <input matInput #middleName placeholder="ваше отчество" formControlName="middleName">
          <mat-error *ngIf="form.controls.middleName.invalid">Некоректные данные</mat-error>
          <mat-hint align="end">{{ middleName.value?.length || 0 }}/35</mat-hint>
        </mat-form-field>
        <button
          class="main-profile-settings__profile__button"
          mat-raised-button matTooltip="Сохранить настройки"
          matTooltipPosition="above"
          color="primary"
          [disabled]="!form.valid">Сохранить настройки</button>
      </div>
    </span>
  </form>
</section>
